module.exports = __webpack_public_path__ + "static/media/translate.defecbdb.svg";